import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { CategoryRoutePipe } from 'ish-core/routing/category/category-route.pipe';
import { CustomCategoryImageComponent } from 'ish-shared/dias/components/category/custom-category-image/custom-category-image.component';

/**
 * The Category Tile Component renders a category tile with the image of the
 * category using {@link CategoryImageComponent}.
 *
 * @example
 * <custom-category-tile [categoryUniqueId]="category"></custom-category-tile>
 */

@Component({
  selector: 'custom-category-tile',
  templateUrl: './custom-category-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, CustomCategoryImageComponent, CategoryRoutePipe],
})
export class CustomCategoryTileComponent implements OnInit {
  /**
   * The Category to render a tile for
   */
  readonly categoryUniqueId = input<string>(undefined);

  category$: Observable<CategoryView>;

  constructor(private shoppingFacade: ShoppingFacade) {}

  ngOnInit() {
    this.shoppingFacade.fetchSpecificCategory$(this.categoryUniqueId());

    this.category$ = this.shoppingFacade.category$(this.categoryUniqueId());
  }
}
